/**
 *
 * @param {date} startDate
 * @param {date} endDate
 * @returns {number} a diferença entre as datas inicial e final
 */
export function getDateDifferenceInHours(startDate, endDate) {
  const difference = Math.abs(endDate.getTime() - startDate.getTime())
  return Math.floor(difference / (1000 * 3600))
}

/**
 *
 * @param {*} startDate
 * @param {*} endDate
 * @returns {number} um texto que descreve a diferença de tempo entre as datas
 */
export default function getDateDifference(startDate, endDate) {
  const difference = Math.abs(endDate.getTime() - startDate.getTime())

  let seconds = Math.floor(difference / 1000)

  let minutes = Math.floor(seconds / 60)
  seconds %= 60

  let hours = Math.floor(minutes / 60)
  minutes %= 60

  const days = Math.floor(hours / 24)
  hours %= 24

  let result = ''

  if (days > 0) {
    result += `${days} dia${days > 1 ? 's' : ''}`
  }

  if (hours > 0) {
    if (result !== '') {
      result += ' e '
    }
    result += `${hours} hora${hours > 1 ? 's' : ''}`
  }

  if (days > 0 && hours > 0) {
    return result
  }

  if (minutes > 0) {
    if (result !== '') {
      result += ' e '
    }
    result += `${minutes} minuto${minutes > 1 ? 's' : ''}`
  }

  if (!days && !hours && !minutes) {
    result = 'Menos de 1 minuto'
  }

  return result
}

/**
 *
 * @param {*} dateTime
 * @returns {number} a diferença de tempo em segundos entre a data referência e a data atual
 */
export function getDiferencaEmSegundosParaADataAtual(dateTime) {
  const now = new Date()
  const target = new Date(dateTime)
  const diffInMilliseconds = target - now
  const diffInSeconds = Math.floor(diffInMilliseconds / 1000)

  return Math.abs(diffInSeconds)
}
